export default __webpack_public_path__ + "static/char-s-07-chs-b6d874a5e272acddab6bf4201965c8d1.webp";